import * as FileSaver from 'file-saver';
import { StoreBase } from '../../../common/StoreBase';
import { observable } from 'mobx';
import { getExtension } from 'mime';
import { IAppContext, IQueryOptions } from '../../../models/commonTypes';

export class DownloadStore extends StoreBase {
	@observable isLoading: boolean = false;

	async initialize() { }

	onDownloadAll = async (ids: string[]) => {
		if (!this.isLoading && ids.length > 0) {
			this.saveDocumentZip(ids, 'documents');
		}
	}

	getDocument = async (clientCode: string) => {
		if (clientCode) {
			const { kurtosysApiStore } = this.storeContext;
			const overrideOptions = {
				disableCachableRequests: true,
				queryString: { clientCode },
			};
			return await kurtosysApiStore.retrieveDocument.execute(overrideOptions);
		}
		return;
	}

	getDocumentZip = async (ids: string[]) => {
		if (ids && ids.length > 0) {
			const { kurtosysApiStore } = this.storeContext;
			const overrideOptions = {
				disableCachableRequests: true,
				body: { documentCodes: ids },
			};
			return await kurtosysApiStore.retrieveDocumentZip.execute(overrideOptions);
		}
		return;
	}

	saveDocument = async (payload: any, filename: IQueryOptions): Promise<boolean> => {
		try {
			this.isLoading = true;
			const result: any = await this.getDocument(payload.clientCode);
			const parsedFilename = this.getQueryValue(filename, payload);

			this.saveFile(result, parsedFilename, payload.clientCode);
		}
		catch (e) {
			console.warn(e);
		}
		finally {
			return this.isLoading = false;
		}
	}

	saveDocumentZip = async (ids: string[], filename: string) => {
		try {
			this.isLoading = true;
			const result: any = await this.getDocumentZip(ids);

			this.saveFile(result, filename);
		}
		catch (e) {
			console.warn(e);
		}
		finally {
			this.isLoading = false;
		}
	}

	saveFile = (blob: any, filename: string, clientCode?: string) => {
		const extension = getExtension(blob.type);
		const fullFileName = extension ? `${ filename }.${ extension }` : filename;

		const { appStore, kurtosysApiStore } = this.storeContext;
		const { serviceUrl, token } = kurtosysApiStore;
		const analyticsHelper = appStore.analyticsHelper;

		// The helper might be needed to be switched off due to the user not giving consent
		if (analyticsHelper) {
			let context: Partial<IAppContext> = {
				filename: fullFileName,
			};
			if (clientCode) {
				context = {
					...context,
					url: `${ serviceUrl }/documents/retrieveDocument/?token=${ token }&clientCode=${ clientCode }&filename=${ filename }`,
				};
			}
			analyticsHelper.logEvent({
				context,
				event: 'document_download',
				eventType: 'click',
			});
		}

		FileSaver.saveAs(
			blob,
			fullFileName);
	}


}

